import { Paper as MuiPaper, PaperProps as MuiPaperProps } from "@mui/material";

type PaperProps = MuiPaperProps;

export const Paper = ({ children, ...props }: PaperProps) => {
  return <MuiPaper {...props}>{children}</MuiPaper>;
};
